import { Link } from "react-router-dom";

type BreadcrumbItem = {
  label: string;
  to?: string;
};

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="transition-colors hover:text-primary-600"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-700" : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && (
                <span className="inline-flex h-3 w-3 items-center justify-center text-foreground-400">
                  <i className="ri-arrow-right-s-line" />
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}